"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ODROfflineCrossSectionsSnackbar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const i18n_1 = require("@completeanatomy/i18n");
function ODROfflineCrossSectionsSnackbar({ isOpen, onClose, }) {
    return ((0, jsx_runtime_1.jsx)(ui_1.OfflineSnackbar, { isOpen: isOpen, onClose: onClose, "data-e2e": 'ODROfflineCrossSectionsSnackbar_OfflineSnackbar', children: (0, i18n_1.Localized)(i18n_1.Strings.snackbar.offlineCrossSections) }));
}
exports.ODROfflineCrossSectionsSnackbar = ODROfflineCrossSectionsSnackbar;
